module.exports = __webpack_public_path__ + "img/shelin.5add37c7.jpg";